// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"3d1cd30a","239":"bcae551d","240":"e78d8edd","354":"46f8f1c2","359":"e8394560","455":"29e59959","642":"4ab90722","764":"de94066a","879":"05caf95d","977":"20607526"}[chunkId] + ".chunk.js";
};